export default (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2058_5028)">
      <path d="M11.4343 19.92L10.901 23.2641C10.8873 23.3205 10.886 23.3793 10.897 23.4363C10.908 23.4934 10.9312 23.5474 10.965 23.5947C10.9967 23.6443 11.039 23.6862 11.0887 23.7175C11.1385 23.7489 11.1946 23.7689 11.253 23.7761H11.4077C11.466 23.7909 11.5267 23.7934 11.586 23.7834C11.6453 23.7734 11.7019 23.7511 11.7521 23.7179C11.8023 23.6848 11.8451 23.6415 11.8776 23.5909C11.9101 23.5403 11.9317 23.4835 11.941 23.424L12.6823 20.0214" />
      <path d="M19.3542 20.0479L20.1008 23.4506C20.1094 23.5086 20.1299 23.5641 20.1611 23.6137C20.1924 23.6633 20.2336 23.7058 20.2822 23.7386C20.3301 23.7711 20.3841 23.7936 20.4409 23.8046C20.4978 23.8156 20.5563 23.8149 20.6128 23.8026H20.7728C20.831 23.7947 20.8868 23.7745 20.9365 23.7432C20.9862 23.7119 21.0286 23.6703 21.0608 23.6213C21.1238 23.5234 21.1468 23.4049 21.1249 23.2906L20.5915 19.9466" />
      <path
        d="M10.1281 20.08C9.92579 20.0731 9.73396 19.9882 9.59279 19.8431C9.45163 19.6979 9.37208 19.5038 9.37082 19.3013V14.64C9.37222 14.4396 9.45245 14.2477 9.59418 14.106C9.7359 13.9643 9.92772 13.884 10.1281 13.8826H10.4801C10.662 13.8834 10.8375 13.9495 10.9746 14.069C11.1117 14.1885 11.2012 14.3533 11.2268 14.5333L11.6055 17.28C11.6198 17.4143 11.6846 17.5382 11.7868 17.6267C11.8833 17.7143 12.0085 17.7637 12.1388 17.7653H19.8562C19.988 17.7661 20.1155 17.718 20.214 17.6304C20.3125 17.5427 20.375 17.4217 20.3895 17.2906L20.7682 14.5333C20.7938 14.3533 20.8833 14.1885 21.0204 14.069C21.1575 13.9495 21.333 13.8834 21.5148 13.8826H21.8668C21.9672 13.8812 22.0668 13.8998 22.1599 13.9372C22.2531 13.9746 22.3378 14.0302 22.4093 14.1007C22.4807 14.1711 22.5375 14.2551 22.5762 14.3477C22.6149 14.4403 22.6348 14.5396 22.6348 14.64V19.3013C22.6339 19.4994 22.5581 19.6898 22.4226 19.8343C22.287 19.9787 22.1018 20.0665 21.9042 20.08H10.1281Z"
        stroke="#1A1A1A"
        strokeWidth="1.06667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3677 13.7332V10.4159C10.367 10.1227 10.4242 9.83221 10.5359 9.56111C10.6476 9.29002 10.8117 9.04363 11.0188 8.83605C11.2259 8.62847 11.4719 8.46379 11.7427 8.35142C12.0135 8.23905 12.3038 8.18121 12.597 8.18121H19.3917C19.984 8.18262 20.5515 8.41851 20.9703 8.83729C21.3891 9.25606 21.625 9.82364 21.6264 10.4159V13.7332"
        stroke="#1A1A1A"
        strokeWidth="1.06667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.53851 2.45343C5.53297 4.10935 3.16346 6.71776 1.80297 9.86806C0.442486 13.0184 0.168285 16.5317 1.02353 19.8549C1.87877 23.1781 3.81489 26.1226 6.52712 28.2247C9.23934 30.3269 12.5737 31.4674 16.0052 31.4668C16.6399 31.4638 17.274 31.4228 17.9038 31.3441"
        stroke="#1A1A1A"
        strokeWidth="1.06667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.4612 29.5467C26.4667 27.8908 28.8363 25.2824 30.1967 22.1321C31.5572 18.9818 31.8314 15.4685 30.9762 12.1453C30.1209 8.82204 28.1848 5.87758 25.4726 3.7754C22.7604 1.67323 19.426 0.53271 15.9945 0.533387C15.3599 0.534807 14.7259 0.573988 14.0959 0.650721"
        stroke="#1A1A1A"
        strokeWidth="1.06667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.5144 26.3043L22.5011 30.0803L26.3358 30.8163"
        stroke="#1A1A1A"
        strokeWidth="1.06667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.59215 5.65883L9.61081 1.88816L5.77081 1.15216"
        stroke="#1A1A1A"
        strokeWidth="1.06667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2058_5028">
        <rect width="32" height="32" />
      </clipPath>
    </defs>
  </svg>
);
